export default __webpack_public_path__ + "static/media/helm_of_the_vanguard.08c54197.jpg";